export default __webpack_public_path__ + "static/media/question-mark-bg-green.9b1afd75.svg";